module.exports = __webpack_public_path__ + "static/voiceman-18f44109fea6bf12ce271194de3e8828.png";